import { render, staticRenderFns } from "./SetPlace.vue?vue&type=template&id=7668960a&scoped=true&"
import script from "./SetPlace.vue?vue&type=script&lang=js&"
export * from "./SetPlace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7668960a",
  null
  
)

export default component.exports